import propertyCardFrontImg from '../assets/images/hints/propertyCardFront.png';
import propertyCardBackImg from '../assets/images/hints/propertyCardBack.png';

export const PROPERTY_CARD_HINTS = {
    propertyCardFront: {
        id: 'propertyCardFront',
        title: 'Frente licencia de tránsito (tarjeta de propiedad)',
        subtitle: 'La licencia de tránsito (tarjeta de propiedad) del vehículo que quieres inspeccionar.',
        hint: 'Toma una foto clara de la parte frontal de la licencia de tránsito (tarjeta de propiedad). Asegúrate de que todos los datos sean legibles y no haya reflejos.',
        image: propertyCardFrontImg,
    },
    propertyCardBack: {
        id: 'propertyCardBack',
        title: 'Reverso licencia de tránsito (tarjeta de propiedad)',
        subtitle: 'La licencia de tránsito (tarjeta de propiedad) del vehículo que quieres inspeccionar.',
        hint: 'Toma una foto clara de la parte posterior de la licencia de tránsito (tarjeta de propiedad). Verifica que toda la información esté visible.',
        image: propertyCardBackImg,
    },
};
